import React from 'react'
import moment from 'moment'
import Back from '../Back/Back'
import "./ManageTitle.css"
import favicon from "../../Assets/favicon.ico"
import Button from '../Button/Button'
import { formatDate } from '../../helper/formatDate'
import { useLocation, useNavigate } from 'react-router-dom'

const ManageTitle = (props) => {
    const { eventLogo, eventName, eventType, eventDate, button, textButton, className, onClick, textBtnHandler, loading, textBtnClass, onBackClick } = props
    const eventDateConverted = moment(formatDate(eventDate)).format(" MMMM Do, YYYY")
    const navigate = useNavigate()
    const location = useLocation()
    const eventId = new URLSearchParams(location.search).get('id')

    // Clicking the event logo returns to THIS event's dashboard (the manage
    // tiles page) when the page URL carries the event id; otherwise fall back
    // to the organizer dashboard as before.
    const navigateToDashboard = () => {
        if (eventId) {
            eventType === "Feiseanna"
                ? navigate(`/organizer-manage-feis?id=${eventId}&Manage=feis`)
                : navigate(`/organizer-manage-grade?id=${eventId}&Manage=grade`)
            return
        }
        navigate("/organizer-dashboard")
    }

    return (
        <>
            {!button && !textButton && <> <div className="manage-header">
                <div className={loading ? "invisible" : ""}>
                    <div className="my-3"><Back onBackClick={onBackClick} /></div>
                    <div className="d-flex align-items-center gap-2 my-2">
                        <img className="manage-title-img" src={eventLogo ? eventLogo : favicon} alt="" title="Back to event dashboard" onClick={navigateToDashboard}/>
                        <div className="org-title-name">{eventName}</div>
                    </div>
                    <div className="d-flex align-items-center gap-2 my-2 mb-4">
                        <div className="manage-title-type">{eventType === "Feiseanna" ? "Feisanna" : "Grade Exam"}</div>
                        <div className="manage-title-date">{eventDateConverted}</div>
                    </div>
                </div>
            </div>
            </>}
            {((button && !textButton) || (!button && textButton)) && <div className="manage-header">
                <div className={loading ? "invisible" : "title-with-btn"}>
                    <div >
                        <div className="my-3"><Back onBackClick={onBackClick} /></div>
                        <div className="d-flex align-items-center gap-2 my-2">
                            <img className="manage-title-img" src={eventLogo ? eventLogo : favicon} alt="" title="Back to event dashboard" onClick={navigateToDashboard}/>
                            <div className="org-title-name">{eventName}</div>
                        </div>
                        <div className="d-flex align-items-center gap-2 my-2 mb-4">
                            <div className="manage-title-type">{eventType === "Feiseanna" ? "Feisanna" : "Grade Exam"}</div>
                            <div className="manage-title-date">{eventDateConverted}</div>
                        </div>
                    </div>
                    <div className="title-btn-div mb-4">
                        {button && !textButton && <Button className={className} onClick={onClick}>{button}</Button>}
                        {!button && textButton && <Button className={textBtnClass || className} onClick={textBtnHandler}>{textButton}</Button>}
                    </div>
                </div>
            </div>}

            {button && textButton && <div className="manage-header">
                <div className={loading ? "invisible" : "title-with-btn"}>
                    <div style={{ width: "100%" }}>
                        <div className="my-3"><Back onBackClick={onBackClick} /></div>
                        <div className="d-flex align-items-center gap-2 my-2">
                            <img className="manage-title-img" src={eventLogo ? eventLogo : favicon} alt="" title="Back to event dashboard" onClick={navigateToDashboard}/>
                            <div className="org-title-name">{eventName}</div>
                        </div>
                        <div className="d-md-flex justify-content-between align-items-start">
                            <div className="d-flex align-items-center gap-2 my-0 ">
                                <div className="manage-title-type">{eventType === "Feiseanna" ? "Feisanna" : "Grade Exam"}</div>
                                <div className="manage-title-date">{eventDateConverted}</div>
                            </div>
                            <div className="title-btn-div d-flex align-items-center justify-content-between mb-1 gap-2">
                                <div>
                                    <Button className={textBtnClass ? textBtnClass : "text-btn px-0"} onClick={textBtnHandler}>{textButton}</Button>
                                </div>
                                <div>
                                    <Button className={className} onClick={onClick}>{button}</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            <div className="hr-org-title" />
        </>
    )
}

export default ManageTitle